import { Link as RouterLink } from 'react-router-dom';
import { Stack, Typography } from '@rossum/ui/material';

type AnnotationLinkColumnProps = {
  annotationId: number;
};

export const AnnotationLinkColumn = ({
  annotationId,
}: AnnotationLinkColumnProps) => {
  return (
    <Stack
      sx={{
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <Typography
        to={`/document/${annotationId}`}
        component={RouterLink}
        variant="body2"
        color="secondary"
        onClick={e => e.stopPropagation()}
        sx={{
          maxWidth: '100%',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {annotationId}
      </Typography>
    </Stack>
  );
};
